<form
  #dynamicForm="ngForm"
  id="{{ formName }}"
  class="dynamic_form"
  novalidate
  (ngSubmit)="onFormSubmit()"
>
  <button class="invisible-submit-button"></button>
  <div>
    <ng-template
      ngFor
      let-element
      [ngForOf]="(formData && formData.elements) || []"
    >
      <div *ngIf="formData.description" class="col-12 text-center mb-3">
        {{ formData.description }}
      </div>
      <ng-container
        *ngTemplateOutlet="elementTpl; context: { element: element }"
      >
      </ng-container>
    </ng-template>

    <ng-template let-element="element" #elementTpl>
      <ng-container [ngSwitch]="element.type">
        <div class="form-element-row" *ngSwitchCase="maps.ELEMENT_TYPES.row">
          <ng-template ngFor let-element [ngForOf]="element.elements">
            <ng-container
              *ngTemplateOutlet="elementTpl; context: { element: element }"
            >
            </ng-container>
          </ng-template>
        </div>

        <div
          class="form-element-column"
          [style]="element.style"
          *ngSwitchCase="maps.ELEMENT_TYPES.column"
        >
          <ng-template ngFor let-element [ngForOf]="element.elements">
            <ng-container
              *ngTemplateOutlet="elementTpl; context: { element: element }"
            >
            </ng-container>
          </ng-template>
        </div>

        <div class="form-element-text" *ngSwitchCase="maps.ELEMENT_TYPES.text">
          <p [style]="element.style">{{ element.text }}</p>
        </div>

        <div class="form-element-url" *ngSwitchCase="maps.ELEMENT_TYPES.link">
          <p>
            <a
              [style]="element.style"
              href="{{ element.url }}"
              target="_blank"
              >{{ element.text }}</a
            >
          </p>
        </div>

        <div
          class="form-element-button"
          *ngSwitchCase="maps.ELEMENT_TYPES.button"
        >
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="disabled"
            (click)="execFormElementOnClick(element)"
            [style]="element.style"
          >
            {{ element.text }}
          </button>
        </div>

        <div
          class="form-element-field mb-3"
          *ngSwitchCase="maps.ELEMENT_TYPES.field"
          [style]="element.style"
        >
          <ng-container *ngIf="getFieldByName(element.field); let field">
            <ng-container
              [ngSwitch]="field.type"
              *ngIf="!isFormFieldHidden(field)"
            >
              <!-- StringField type -->
              <div
                class="form-group"
                [ngClass]="{ 'is-required': field.required }"
                *ngSwitchCase="maps.FIELD_TYPES.string"
              >
                <ng-container [ngSwitch]="field.widget">
                  <label for="{{ field.name }}" class="form-control-label">{{
                    field.label
                  }}</label>
                  <span *ngIf="field.required" class="required"></span>
                  <fa-icon
                    *ngIf="field.tooltip"
                    class="cursor-pointer fa-lg ms-2"
                    [icon]="faCircleInfo"
                    [ngbTooltip]="field.tooltip"
                  ></fa-icon>
                  <ng-container
                    *ngIf="
                      field.widget !== maps.STRING_FIELD_WIDGETS.textarea;
                      else textareaTemplate
                    "
                  >
                    <input
                      type="text"
                      name="{{ field.name }}"
                      id="{{ field.name }}"
                      class="form-control"
                      [ngClass]="{ 'is-invalid': validationError(field) }"
                      [required]="field.required ? field.required : false"
                      [readonly]="field.readOnly"
                      [pattern]="field.pattern"
                      [disabled]="disabled || isFormFieldDisabled(field)"
                      [(ngModel)]="field.value"
                      (ngModelChange)="onChange(); execFormFieldOnChange(field)"
                      #inputText="ngModel"
                    />

                    <div class="invalid-feedback" *ngIf="inputText.invalid">
                      <p *ngIf="inputText.errors?.pattern">
                        {{ maps.INPUT_ERRORS_MESSAGES.PATTERN_NO_MATCH }}
                      </p>
                      <p *ngIf="inputText.errors?.required">
                        {{ maps.INPUT_ERRORS_MESSAGES.REQUIRED }}
                      </p>
                    </div>
                  </ng-container>

                  <ng-template #textareaTemplate>
                    <textarea
                      name="{{ field.name }}"
                      id="{{ field.name }}"
                      class="form-control"
                      [ngClass]="{ 'is-invalid': validationError(field) }"
                      [required]="field.required ? field.required : false"
                      [readonly]="field.readOnly"
                      [disabled]="disabled || isFormFieldDisabled(field)"
                      [(ngModel)]="field.value"
                      (ngModelChange)="onChange(); execFormFieldOnChange(field)"
                      #textBox="ngModel"
                      rows="{{ field.rows || 5 }}"
                    >
                  {{ field.value }}
                  </textarea
                    >
                    <div class="invalid-feedback" *ngIf="textBox.invalid">
                      <p *ngIf="textBox.errors?.required">
                        {{ maps.INPUT_ERRORS_MESSAGES.REQUIRED }}
                      </p>
                    </div>
                  </ng-template>
                </ng-container>
              </div>

              <!-- NumberFiled type -->
              <div
                class="form-group"
                [ngClass]="{ 'is-required': field.required }"
                *ngSwitchCase="maps.FIELD_TYPES.number"
              >
                <label for="{{ field.name }}" class="form-control-label">{{
                  field.label
                }}</label>
                <span *ngIf="field.required" class="required"></span>
                <fa-icon
                  *ngIf="field.tooltip"
                  class="cursor-pointer fa-lg ms-2"
                  [icon]="faCircleInfo"
                  [ngbTooltip]="field.tooltip"
                ></fa-icon>
                <input
                  type="number"
                  name="{{ field.name }}"
                  id="{{ field.name }}"
                  class="form-control"
                  [ngClass]="{ 'is-invalid': validationError(field) }"
                  [required]="field.required ? field.required : false"
                  [readonly]="field.readOnly"
                  [disabled]="disabled || isFormFieldDisabled(field)"
                  [step]="field.step || 'any'"
                  [min]="field.min ? field.min : null"
                  [max]="field.max ? field.max : null"
                  [(ngModel)]="field.value"
                  (ngModelChange)="onChange(); execFormFieldOnChange(field)"
                  #numberField="ngModel"
                />

                <div class="invalid-feedback" *ngIf="validationError(field)">
                  <p *ngIf="numberField.errors?.required">
                    {{ maps.INPUT_ERRORS_MESSAGES.REQUIRED }}
                  </p>
                  <p
                    *ngIf="
                      numberField.errors &&
                      numberField.errors[maps.INPUT_CUSTOM_ERRORS.RANGE_OVER]
                    "
                  >
                    {{ maps.INPUT_ERRORS_MESSAGES.RANGE_OVER }}
                  </p>
                  <p
                    *ngIf="
                      numberField.errors &&
                      numberField.errors[maps.INPUT_CUSTOM_ERRORS.RANGE_UNDER]
                    "
                  >
                    {{ maps.INPUT_ERRORS_MESSAGES.RANGE_UNDER }}
                  </p>
                </div>
              </div>

              <!-- ListFiled type -->
              <div
                class="form-group"
                [ngClass]="{ 'is-required': field.required }"
                *ngSwitchCase="maps.FIELD_TYPES.list"
              >
                <ng-container *ngIf="!field.loading; else spinner">
                  <ng-container [ngSwitch]="field.widget">
                    <ng-container
                      *ngSwitchCase="maps.LIST_FIELD_WIDGETS.select"
                    >
                      <label
                        for="{{ field.name }}"
                        class="form-control-label"
                        >{{ field.label }}</label
                      >
                      <span *ngIf="field.required" class="required"></span>
                      <fa-icon
                        *ngIf="field.tooltip"
                        class="cursor-pointer fa-lg ms-2"
                        [icon]="faCircleInfo"
                        [ngbTooltip]="field.tooltip"
                      ></fa-icon>
                      <select
                        name="{{ field.name }}"
                        id="{{ field.name }}"
                        class="custom-select"
                        [multiple]="isMultiple(field)"
                        [ngClass]="{ 'is-invalid': validationError(field) }"
                        [required]="field.required ? field.required : false"
                        [disabled]="
                          field.readOnly ||
                          disabled ||
                          isFormFieldDisabled(field)
                        "
                        [(ngModel)]="field.value"
                        (ngModelChange)="
                          onChange(); execFormFieldOnChange(field)
                        "
                        [size]="isMultiple(field) ? field.items?.length : 1"
                        #selectField="ngModel"
                      >
                        <option hidden></option>
                        <option
                          *ngFor="let option of field.items"
                          [value]="option.value"
                          [disabled]="option.disabled === true"
                        >
                          {{ option.label }}
                        </option>
                      </select>

                      <div
                        class="invalid-feedback"
                        *ngIf="validationError(field)"
                      >
                        <p *ngIf="selectField.errors?.required">
                          {{ maps.INPUT_ERRORS_MESSAGES.REQUIRED }}
                        </p>
                        <p
                          *ngIf="
                            selectField.errors &&
                            selectField.errors[
                              maps.INPUT_CUSTOM_ERRORS.CHOICES_TOO_MANY
                            ]
                          "
                        >
                          {{ maps.INPUT_ERRORS_MESSAGES.CHOICES_TOO_MANY }}
                        </p>
                        <p
                          *ngIf="
                            selectField.errors &&
                            selectField.errors[
                              maps.INPUT_CUSTOM_ERRORS.CHOICES_TOO_FEW
                            ]
                          "
                        >
                          {{ maps.INPUT_ERRORS_MESSAGES.CHOICES_TOO_FEW }}
                        </p>
                      </div>
                    </ng-container>

                    <ng-container
                      *ngSwitchCase="maps.LIST_FIELD_WIDGETS.checkboxes"
                    >
                      <label
                        class="form-control-label" for="{{ field.name }}__{{ field.value }}"
                        [ngClass]="{ 'is-invalid': validationError(field) }"
                        >{{ field.label }}</label
                      >

                      <span *ngIf="field.required" class="required"></span>
                      <fa-icon
                        *ngIf="field.tooltip"
                        class="cursor-pointer fa-lg ms-2"
                        [icon]="faCircleInfo"
                        [ngbTooltip]="field.tooltip"
                      ></fa-icon>
                      <div
                        class="custom-control custom-checkbox"
                        *ngFor="let item of field.items"
                      >
                        <input
                          type="hidden"
                          name="{{ field.name }}"
                          [required]="field.required ? field.required : false"
                          [(ngModel)]="field.value"
                          #checkListfield="ngModel"
                        />

                        <input
                          type="checkbox"
                          name="checkbox__{{ field.name }}__{{ item.value }}"
                          id="{{ field.name }}__{{ item.value }}"
                          class="custom-control-input"
                          [value]="item.value"
                          [disabled]="
                            field.readOnly ||
                            disabled ||
                            isFormFieldDisabled(field) ||
                            item.disabled === true
                          "
                          (change)="onCheckboxChange(field, item.value)"
                          [checked]="isCheckboxChecked(field.value, item.value)"
                          #checkField
                        />
                        <label
                          for="{{ field.name }}__{{ item.value }}"
                          class="custom-control-label"
                          >{{ item.label }}</label
                        >
                      </div>

                      <div
                        class="invalid-feedback"
                        *ngIf="validationError(field)"
                      >
                        <p
                          *ngIf="
                            dynamicForm.form.controls[field.name].errors
                              ?.required
                          "
                        >
                          {{ maps.INPUT_ERRORS_MESSAGES.REQUIRED }}
                        </p>
                        <p
                          *ngIf="
                            dynamicForm.form.controls[field.name].errors![
                              maps.INPUT_CUSTOM_ERRORS.CHOICES_TOO_MANY
                            ]
                          "
                        >
                          {{ maps.INPUT_ERRORS_MESSAGES.CHOICES_TOO_MANY }}
                        </p>
                        <p
                          *ngIf="
                            dynamicForm.form.controls[field.name].errors![
                              maps.INPUT_CUSTOM_ERRORS.CHOICES_TOO_FEW
                            ]
                          "
                        >
                          {{ maps.INPUT_ERRORS_MESSAGES.CHOICES_TOO_FEW }}
                        </p>
                      </div>
                    </ng-container>

                    <ng-container
                      *ngSwitchCase="maps.LIST_FIELD_WIDGETS.radios"
                    >
                      <label
                        class="form-control-label" for="{{ field.name }}__{{ field.value }}"
                        [ngClass]="{ 'is-invalid': validationError(field) }"
                        >{{ field.label }}</label
                      >
                      <span *ngIf="field.required" class="required"></span>
                      <fa-icon
                        *ngIf="field.tooltip"
                        class="cursor-pointer fa-lg ms-2"
                        [icon]="faCircleInfo"
                        [ngbTooltip]="field.tooltip"
                      ></fa-icon>
                      <!-- added to manage disabled state because in input should be bugged -->
                      <fieldset
                        [disabled]="
                          field.readOnly ||
                          disabled ||
                          isFormFieldDisabled(field)
                        "
                      >
                        <legend></legend>
                        <div
                          class="custom-control custom-radio"
                          *ngFor="let item of field.items"
                        >
                          <input
                            type="radio"
                            name="{{ field.name }}"
                            id="{{ field.name }}__{{ item.value }}"
                            class="custom-control-input"
                            value="{{ item.value }}"
                            [(ngModel)]="field.value"
                            [required]="field.required ? field.required : false"
                            [checked]="field.value === item.value"
                            (change)="onChange(); execFormFieldOnChange(field)"
                            #radioField="ngModel"
                            [disabled]="item.disabled === true"
                          />

                          <label
                            for="{{ field.name }}__{{ item.value }}"
                            class="custom-control-label"
                            >{{ item.label }}</label
                          >
                        </div>
                      </fieldset>
                      <div
                        class="invalid-feedback"
                        *ngIf="validationError(field)"
                      >
                        <p
                          *ngIf="
                            dynamicForm.form.controls[field.name].errors
                              ?.required
                          "
                        >
                          {{ maps.INPUT_ERRORS_MESSAGES.REQUIRED }}
                        </p>
                      </div>
                    </ng-container>

                    <ng-container
                      *ngSwitchCase="maps.LIST_FIELD_WIDGETS.autocomplete"
                    >
                      <label
                        for="{{ field.name }}"
                        class="form-control-label"
                        >{{ field.label }}</label
                      >
                      <span *ngIf="field.required" class="required"></span>
                      <fa-icon
                        *ngIf="field.tooltip"
                        class="cursor-pointer fa-lg ms-2"
                        [icon]="faCircleInfo"
                        [ngbTooltip]="field.tooltip"
                      ></fa-icon>
                      <ng-select
                        class="custom-control"
                        [multiple]="isMultiple(field)"
                        [maxSelectedItems]="field.max ? +field.max : -1"
                        [ngClass]="{ 'is-invalid': validationError(field) }"
                        [name]="field.name"
                        [id]="field.name"
                        [items]="field.items ? field.items : null"
                        [required]="field.required ? field.required : false"
                        [disabled]="
                          field.readOnly ||
                          disabled ||
                          isFormFieldDisabled(field)
                        "
                        bindValue="value"
                        (ngModelChange)="
                          !isMultiple(field)
                            ? (field.value = $event !== null ? [$event] : null)
                            : (field.value = $event);
                          onChange();
                          execFormFieldOnChange(field)
                        "
                        [ngModel]="
                          !isMultiple(field)
                            ? field.value
                              ? field.value[0]
                              : field.value
                            : field.value
                        "
                        #autocompleteField="ngModel"
                        [virtualScroll]="true"
                      >
                      </ng-select>
                      <div
                        class="invalid-feedback"
                        *ngIf="validationError(field)"
                      >
                        <p *ngIf="autocompleteField.errors?.required">
                          {{ maps.INPUT_ERRORS_MESSAGES.REQUIRED }}
                        </p>
                      </div>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                      <label
                        for="{{ field.name }}"
                        class="form-control-label"
                        >{{ field.label }}</label
                      >
                      <span *ngIf="field.required" class="required"></span>
                      <fa-icon
                        *ngIf="field.tooltip"
                        class="cursor-pointer fa-lg ms-2"
                        [icon]="faCircleInfo"
                        [ngbTooltip]="field.tooltip"
                      ></fa-icon>
                      <select
                        name="{{ field.name }}"
                        id="{{ field.name }}"
                        class="custom-select"
                        [multiple]="isMultiple(field)"
                        [ngClass]="{ 'is-invalid': validationError(field) }"
                        [required]="field.required ? field.required : false"
                        [disabled]="
                          field.readOnly ||
                          disabled ||
                          isFormFieldDisabled(field)
                        "
                        [(ngModel)]="field.value"
                        (ngModelChange)="
                          onChange(); execFormFieldOnChange(field)
                        "
                        #selectField="ngModel"
                      >
                        <option hidden></option>
                        <option
                          *ngFor="let option of field.items"
                          [value]="option.value"
                          [disabled]="option.disabled === true"
                        >
                          {{ option.label }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="validationError(field)"
                      >
                        <p *ngIf="selectField.errors?.required">
                          {{ maps.INPUT_ERRORS_MESSAGES.REQUIRED }}
                        </p>
                        <p
                          *ngIf="
                            selectField.errors![
                              maps.INPUT_CUSTOM_ERRORS.CHOICES_TOO_MANY
                            ]
                          "
                        >
                          {{ maps.INPUT_ERRORS_MESSAGES.CHOICES_TOO_MANY }}
                        </p>
                        <p
                          *ngIf="
                            selectField.errors![
                              maps.INPUT_CUSTOM_ERRORS.CHOICES_TOO_FEW
                            ]
                          "
                        >
                          {{ maps.INPUT_ERRORS_MESSAGES.CHOICES_TOO_FEW }}
                        </p>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-template #spinner>
                  <label for="{{ field.name }}" class="form-control-label">
                    {{ field.label }}
                  </label>
                  <div class="spinner"></div>
                  <p>
                    <fa-icon
                      class="fa-lg me-2 mt-2"
                      [ngClass]="{ 'text-danger': field.error }"
                      [icon]="field.error ? faCircleXmark : faSpinner"
                    ></fa-icon>
                    {{ (field.error ? "ERROR" : "LOADING") | translate }}
                  </p>
                </ng-template>
              </div>

              <div
                class="form-group"
                [ngClass]="{ 'is-required': field.required }"
                *ngSwitchCase="maps.FIELD_TYPES.boolean"
              >
                <div
                  class="custom-control"
                  [ngClass]="{
                    'custom-checkbox':
                      field.widget === maps.BOOLEAN_FIELD_WIDGETS.checkbox,
                    'custom-switch':
                      field.widget === maps.BOOLEAN_FIELD_WIDGETS.toggle ||
                      !field.widget
                  }"
                >
                  <input
                    type="checkbox"
                    name="{{ field.name }}"
                    id="{{ field.name }}"
                    class="custom-control-input"
                    [ngClass]="{ 'is-invalid': validationError(field) }"
                    [required]="field.required ? field.required : false"
                    [disabled]="
                      field.readOnly || disabled || isFormFieldDisabled(field)
                    "
                    [checked]="field.value"
                    [(ngModel)]="field.value"
                    (ngModelChange)="onChange(); execFormFieldOnChange(field)"
                    #booleanField="ngModel"
                  />
                  <label class="custom-control-label" for="{{ field.name }}">{{
                    field.label
                  }}</label>
                  <span *ngIf="field.required" class="required"></span>
                  <fa-icon
                    *ngIf="field.tooltip"
                    class="cursor-pointer fa-lg ms-2"
                    [icon]="faCircleInfo"
                    [ngbTooltip]="field.tooltip"
                  ></fa-icon>
                  <div class="invalid-feedback" *ngIf="validationError(field)">
                    <p *ngIf="booleanField.errors?.required">
                      {{ maps.INPUT_ERRORS_MESSAGES.REQUIRED }}
                    </p>
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                [ngClass]="{ 'is-required': field.required }"
                *ngSwitchCase="maps.FIELD_TYPES.file"
              >
                <div class="custom-file">
                  <input
                    type="file"
                    class="custom-file-input"
                    [ngClass]="{
                      'is-invalid':
                        validationError(field) ||
                        (fieldFile.errors &&
                          fieldFile.errors[
                            maps.INPUT_CUSTOM_ERRORS.MAX_SIZE
                          ]) ||
                        (fieldFile.errors &&
                          fieldFile.errors[maps.INPUT_CUSTOM_ERRORS.FILE_TYPE])
                    }"
                    [name]="field.name"
                    (change)="onChangeFile($event, field)"
                    [accept]="field.allowedMimeTypes"
                    [required]="field.required ? field.required : false"
                    id="{{ field.name }}"
                    [disabled]="
                      field.readOnly || disabled || isFormFieldDisabled(field)
                    "
                    #fieldFile="ngModel"
                    ngModel
                  />

                  <label
                    class="custom-file-label"
                    for="{{ field.name }}"
                    data-browse="..."
                    >{{ field.label }}</label
                  >

                  <span *ngIf="field.required" class="required"></span>
                  <fa-icon
                    *ngIf="field.tooltip"
                    class="cursor-pointer fa-lg ms-2"
                    [icon]="faCircleInfo"
                    [ngbTooltip]="field.tooltip"
                  ></fa-icon>
                  <div class="invalid-feedback" *ngIf="validationError(field)">
                    <p *ngIf="fieldFile.errors?.required">
                      {{ maps.INPUT_ERRORS_MESSAGES.REQUIRED }}
                    </p>
                  </div>
                  <div
                    class="invalid-feedback"
                    *ngIf="
                      (fieldFile.errors &&
                        fieldFile.errors[maps.INPUT_CUSTOM_ERRORS.MAX_SIZE]) ||
                      (fieldFile.errors &&
                        fieldFile.errors[maps.INPUT_CUSTOM_ERRORS.FILE_TYPE])
                    "
                  >
                    <p
                      *ngIf="
                        fieldFile.errors &&
                        fieldFile.errors[maps.INPUT_CUSTOM_ERRORS.MAX_SIZE]
                      "
                    >
                      {{ maps.INPUT_ERRORS_MESSAGES.MAX_SIZE }}
                    </p>
                    <p
                      *ngIf="
                        fieldFile.errors &&
                        fieldFile.errors[maps.INPUT_CUSTOM_ERRORS.FILE_TYPE]
                      "
                    >
                      {{ maps.INPUT_ERRORS_MESSAGES.FILE_TYPE }}
                    </p>
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                [ngClass]="{ 'is-required': field.required }"
                *ngSwitchCase="maps.FIELD_TYPES.dateTime"
              >
                <label for="{{ field.name }}" class="form-control-label">{{
                  field.label
                }}</label>
                <span *ngIf="field.required" class="required"></span>
                <fa-icon
                  *ngIf="field.tooltip"
                  class="cursor-pointer fa-lg ms-2"
                  [icon]="faCircleInfo"
                  [ngbTooltip]="field.tooltip"
                ></fa-icon>
                <div class="input-group">
                  <ng-container
                    *ngIf="
                      field.widget === maps.DATETIME_FIELD_TYPES.datepicker
                    "
                  >
                    <input
                      matInput
                      [matDatepicker]="dpicker"
                      placeholder="Choose a date"
                      [name]="field.name"
                      [id]="field.name"
                      class="form-control"
                      [disabled]="disabled || isFormFieldDisabled(field)"
                      [readOnly]="field.readOnly"
                      [required]="field.required ? field.required : false"
                      [ngClass]="{ 'is-invalid': validationError(field) }"
                      aria-label="Data"
                      [min]="field.min ? field.min : null"
                      [max]="field.max ? field.max : null"
                      [disabled]="disabled"
                    />
                    <mat-datepicker #dpicker></mat-datepicker>
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="$any(dpicker)"
                    ></mat-datepicker-toggle>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      field.widget === maps.DATETIME_FIELD_TYPES.datetimepicker
                    "
                  >
                    <input
                      matInput
                      [ngxMatDatetimePicker]="dtpicker"
                      placeholder="Choose a date"
                      [name]="field.name"
                      [id]="field.name"
                      class="form-control"
                      [disabled]="disabled || isFormFieldDisabled(field)"
                      [readOnly]="field.readOnly"
                      [required]="field.required ? field.required : false"
                      [ngClass]="{ 'is-invalid': validationError(field) }"
                      aria-label="Data"
                      [min]="field.min ? field.min : null"
                      [max]="field.max ? field.max : null"
                      [disabled]="disabled"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="$any(dtpicker)"
                    ></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker
                      #dtpicker
                      [showSpinners]="true"
                      [showSeconds]="false"
                      [stepHour]="1"
                      [stepMinute]="5"
                      [touchUi]="false"
                      [color]="'accent'"
                      [enableMeridian]="false"
                      [hideTime]="false"
                    >
                    </ngx-mat-datetime-picker>
                  </ng-container>
                </div>
              </div>

              <div class="form-group" *ngSwitchCase="maps.FIELD_TYPES.form">
                <app-dynamic-form
                  [formName]="formName + '_subForm_' + field.name"
                  [formData]="field.value"
                  [form]="formData!"
                  [disabled]="disabled || isFormFieldDisabled(field)"
                  [customFunctions]="customFunctions"
                  (formSubmit)="onFormSubmit()"
                  (formValidation)="onSubFormValidation(field.name, $event)"
                  (formChange)="
                    onSubFormChange(field.name, $event);
                    execFormFieldOnChange(field)
                  "
                  [subFormsValidationStatus]="subFormsValidationStatus"
                ></app-dynamic-form>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </ng-template>
  </div>

  <div *ngIf="submitButton">
    <div class="col-12 text-center">
      <button
        type="button"
        class="btn btn-action primary my-3"
        [disabled]="disabled"
        (click)="submit()"
      >
        {{ submitButton }}
      </button>
    </div>
  </div>
</form>
